__turbopack_context__.v({
  "actions": "PricingCard-module-scss-module__ndUEtG__actions",
  "badge": "PricingCard-module-scss-module__ndUEtG__badge",
  "billingCycle": "PricingCard-module-scss-module__ndUEtG__billingCycle",
  "card": "PricingCard-module-scss-module__ndUEtG__card",
  "choosePlanButton": "PricingCard-module-scss-module__ndUEtG__choosePlanButton",
  "description": "PricingCard-module-scss-module__ndUEtG__description",
  "featuresList": "PricingCard-module-scss-module__ndUEtG__featuresList",
  "intro": "PricingCard-module-scss-module__ndUEtG__intro",
  "price": "PricingCard-module-scss-module__ndUEtG__price",
  "seeAll": "PricingCard-module-scss-module__ndUEtG__seeAll",
  "title": "PricingCard-module-scss-module__ndUEtG__title",
  "value": "PricingCard-module-scss-module__ndUEtG__value",
  "withShadow": "PricingCard-module-scss-module__ndUEtG__withShadow",
});
